var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var PlatformConstants = require('./constants/PlatformConstants');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');
var LinkingManager = require('./wrappers/LinkingManager');

import Icon from './wrappers/ReUpIcon';

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKIconToggle
} = MK;

const FBSDK = require('./wrappers/react-native-fbsdk-wrapper');
const {
  LoginManager,
  AccessToken,
} = FBSDK;

var FeedCard = require('./feedCard.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  Platform,
  StyleSheet,
} = ReactNative;

var RNFS = require('./wrappers/react-native-fs');
import Camera from './wrappers/react-native-camera-wrapper';

var Settings = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      user : this.props.appManager.currentUser(),
      showPassword : false,
      selfieURL : null,
    }
  },

  componentDidMount : function()
  {
    var settings = this;
    this.props.appManager.getCurrentUser(function(user)
    {
      settings.props.appManager.getSelfie(function(selfieURL)
      {
        settings.setState({user:user,selfieURL:selfieURL});
      })
    });
  },

  logoutPressed : function()
  {
    var appActions = this.props.appActions;
    var thisThing = this;
    appActions.setSpinnerShown(true, "Logging out...");
    this.props.appManager.logout(function()
    {
      appActions.setSpinnerShown(false);
      appActions.requestPop();
    });
  },

  _camera : null,
  _canCapture : false,
  cameraDidLoad : function(camera)
  {
    if( !camera ) return;
    this._canCapture = true;
    this._camera = camera;
  },

  takePicture : async function()
  {
    if( this._camera && this._canCapture )
    {
      this._canCapture = false;
      try
      {
        var appManager = this.props.appManager;
        var thisThing = this;
        var data = await this._camera.capture({target:Camera.constants.CaptureTarget.disk, mode:Camera.constants.CaptureMode.still, type:Camera.constants.Type.front, quality:'medium'});
          // console.log(data);
        appManager.setSelfie(data, function()
        {
          // console.log("did set selfie")
          appManager.getSelfie(function(selfieURL)
          {
            // console.log("did get selfie with url" + selfieURL)
            thisThing.props.appActions.hideAlert();
            thisThing.setState({selfieURL:selfieURL})
            thisThing.props.appManager._eventEmitter.emit("checkUserChanged", {});
          })
        });
      } catch (e) {
        console.error(e);
      }
    }
  },

  didUpdate: function()
  {

  },

  profilePicSelected : function()
  {
    if( Platform.OS === 'ios' )
    {
      var thisThing = this;
      var appActions = this.props.appActions;
      Camera.checkVideoAuthorizationStatus().then((hasPermission)=>
      {
        if( hasPermission )
        {
          thisThing.showCamera();
        }
        else
        {
          appActions.showAlert("Camera Permission Required","You have not granted permission to use the camera. Please go into your phone's Settings and add the permission.",["Okay"],[function(){appActions.hideAlert();}]);
        }
      })
    }
    else
    {
      this.showCamera();
    }
  },

  showCamera : function()
  {
    var cameraDim = Math.min(this.state.layout.width,this.state.layout.height) - 20;
    var thisThing = this;
    var appManager = thisThing.props.appManager;

    var customAlert = Platform.OS === 'ios' ?
        <ScrollView bounces={true} style={{margin:0,padding:0}}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"}>
          <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'flex-end', padding:10}}
            captureAudio={false}
            captureQuality={"medium"}
            captureTarget={Camera.constants.CaptureTarget.disk}
            type={Camera.constants.Type.front}
            aspect={Camera.constants.Aspect.Fill}>
            <ReUpIconButton iconName={"camera"} type={1} style={{margin:10}}
              appManager={appManager}
              style={{alignSelf:'flex-end'}}
                onPress={() => {
                  thisThing.takePicture();
                }}
                />
          </Camera>
        </ScrollView>
      :
        <ScrollView bounces={true} style={{margin:0,padding:0,paddingBottom:10}}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"}>
          <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'flex-end', padding:10, marginBottom:10}}
            captureAudio={false}
            aspect={Camera.constants.Aspect.Fill}
            captureTarget={Camera.constants.CaptureTarget.disk}
            captureQuality={"medium"}
            type={Camera.constants.Type.front}
            orientation={Camera.constants.Orientation.portrait}>
          </Camera>
          <ReUpIconButton iconName={"camera"} type={1} style={{margin:10}}
            appManager={appManager}
            style={{alignSelf:'flex-end'}}
              onPress={() => {
                thisThing.takePicture();
              }}
              />
        </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert);
  },

  changePasswordPressed : function()
  {
    this._showPassword = false
    this._currentPassword = "";
    this._newPassword = "";
    this._currentPasswordError = false;
    this._newPasswordError = false;

    this.showChangePass();
  },

  _showPassword : false,
  _currentPassword : "",
  _newPassword : "",
  _currentPasswordError: false,
  _newPasswordError: false,
  showChangePass : function()
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var appActions = thisThing.props.appActions;
    var locManager = thisThing.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");

    var locMan = appManager.getLocalizationManager();
    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
    var newPassDescription = locMan.localizedStringForKey("CHANGE_PASSWORD_LABEL");
    var passPlaceholder = locMan.localizedStringForKey("CURRENT_PASSWORD_PLACEHOLDER");
    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
    var currPass = appManager.currentUser()[ModelConstants.Password];

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View style={{flexDirection:'column'}}>
          <ReUpText appManager={appManager} style={{marginTop:10, textAlign:'center'}}>
            {newPassDescription}
          </ReUpText>
          <ReUpField appManager={appManager}
            key="oldPassword"
            tintColor={bannerColor}
            highlightColor={bannerColor}
            onChangeText={(text) => {this._currentPassword = text}}
            placeholder={passPlaceholder}
            secureTextEntry={true}/>
          <View style={styles.passwordContainer}>
            <ReUpField
              onChangeText={(text) => {this._newPassword = text}}
              key="password"
              ref={(a) => thisThing._passwordField = a}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              appManager={appManager}
              placeholder={newPassPlaceholder}
              secureTextEntry={!this._showPassword}
              style={[{flex:1, alignSelf:'center', height:50}]}/>

            <MKIconToggle
              style={{marginTop:22, height:30, width:30, position:'absolute', right:0, backgroundColor:'transparent'}}
              checked={this._showPassword}
              onCheckedChange=
              {
                (info) => {
                  thisThing._passwordField.onBlur();
                  thisThing._showPassword = info.checked;
                  thisThing.showChangePass();

                }
              }
              >
              <Icon pointerEvents="none" state_checked={true} style={[styles.creditCardEditButtonIcon]} name={"eye"} size={14} color={generalTitleColor} />
              <Icon pointerEvents="none" state_checked={false} style={[styles.creditCardEditButtonIcon]} name={"eye-slash"} size={14} color={generalTitleColor} />
            </MKIconToggle>

          </View>
          <ReUpButton onPress={() =>
            {
              if( currPass != thisThing._currentPassword )
              {
                var title = locManager.localizedStringForKey("ERROR_FAIL_ALERT_TITLE");
                var body = locManager.localizedStringForKey("PASSWORD_INCORRECT_BODY");
                var button = locManager.localizedStringForKey("OK_ALERT_BUTTON");
                appActions.showAlert(title,body,[button],[thisThing.showChangePass], function(){})
              }
              else if( appManager.isValidPassword(thisThing._newPassword) )
              {
                thisThing.changePassword(thisThing._newPassword);
              }
              else
              {
                appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE","CHANGE_PASS_FORMAT_FAIL_ALERT_BODY",["OK_ALERT_BUTTON"],[thisThing.showChangePass], function(){})
              }
            }} appManager={this.props.appManager} text={changePasswordButton} style={[styles.logoutButton, {marginTop:10, marginBottom:10}]} />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert);
  },

  changePassword: function(newPass)
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var locMan = appManager.getLocalizationManager();
    var changingPassword = appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD");
    thisThing.props.appActions.setSpinnerShown(true, changingPassword)
    NetworkManager.changePassword(this.props.appManager, newPass, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var user = appManager.getCurrentUser(function(currentUser)
      {
        currentUser[ModelConstants.Password] = newPass;
        appManager.setCurrentUser(currentUser, function()
        {
          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
          var okayButton = locMan.localizedStringForKey("VERSION_OKAY_ALERT_OPTION");

          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function(){thisThing.props.appActions.hideAlert()}], function(){})
        });
      })
    }, function(data)
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
      var okayButton = locMan.localizedStringForKey("OKAY_ALERT_OPTION");

      thisThing.props.appActions.showAlert(title, body, [okayButton], [function(){thisThing.showChangePass()}], function(){})
    }, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      thisThing.props.appActions.showNetworkErrorAlert(function(){thisThing.showChangePass()}, function(){});
    },)
  },

  contactSupport: function()
  {
    var email = this.props.appManager.getSupportEmail();
    var platform = Platform.OS;
    if( platform == "android" ) platform = "Android";
    var subject = this.props.appManager.appNameLong + " Support";
    var body = "Hi, my email is " + this.props.appManager.currentUser()[ModelConstants.UserName] + " and I am on " + platform + ". I am having an issue with...";
    var url = "mailto:"+encodeURI(email)+"?subject="+encodeURI(subject)+"&body="+encodeURI(body);
    LinkingManager.canOpenURL(url, function(can)
    {
      if( can )
      {
        LinkingManager.openURL(url)
      }
    });
  },

  loginFacebookPressed : function()
  {
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var thisThing = this;
    appActions.setSpinnerShown(true);
    LoginManager.logInWithReadPermissions(['email','public_profile']).then(
    function(result)
    {
      if (result.isCancelled)
      {
        console.log("Facebook cancelled");
        appActions.setSpinnerShown(false);
      }
      else
      {
        AccessToken.getCurrentAccessToken().then(
        (data) =>
        {
          var password = data.accessToken.toString();
          NetworkManager.createUserFacebook( appManager, password, "", true, (email)=>
          {
            NetworkManager.login(appManager, email, password, (data)=>
            {
              data[ModelConstants.Password] = password;
              appManager.setCurrentUser(data, function()
              {
                appActions.setSpinnerShown(false);
              })
            }, ()=>
            {
              appActions.setSpinnerShown(false);
            }, ()=>
            {
              appActions.setSpinnerShown(false);
            })
          }, ()=>
          {
            appActions.setSpinnerShown(false);
          })
        })
      }
    },
    function(error)
    {
      appActions.setSpinnerShown(false);
      console.log('Login fail with error: ' + error);
    });
  },

  joinGroupPressed: function()
  {
    this._groupCodeError = false;
    this._groupCode = "";

    this.showJoinGroup();
  },

  _groupCodeError:false,
  _groupCode:"",
  showJoinGroup: function()
  {
    var locMan = this.props.appManager.getLocalizationManager();
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var user = appManager.currentUser();

    var customAlert = <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10}}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"}>
          <View>
            <ReUpText appManager={appManager} isTitle={true} style={{marginTop:10, textAlign:'center'}}>
              {
                locMan.localizedStringForKey("JOIN_GROUP_ALERT_TITLE", "Enter Your Group Code")
              }
            </ReUpText>
            <View style={{
                paddingTop:4,
                paddingLeft:20,
                paddingRight:20,
                alignItems:'center',
                justifyContent:'center',
                flexDirection:'row',
              }}>
              <ReUpField
                key="groupcode"
                ref={(a)=> this._groupCodeField = a}
                appManager={appManager}
                onChangeText={(text) =>
                {
                  thisThing._groupCode = text;
                  if( thisThing._groupCodeError )
                  {
                    thisThing._groupCodeError = false;
                    thisThing.showJoinGroup();
                  }
                }}
                autoCorrect={false}
                isInError={this._groupCodeError}
                defaultValue={this._groupCode}
                useGeneric={true}
                autoCapitalize={'none'}
                onSubmitEditing={this.submitGroupRequest}
                placeholder={this._groupCodeError ? locMan.localizedStringForKey("GROUP_CODE_ERROR_PLACEHOLDER", "invalid group code") : locMan.localizedStringForKey("GROUP_CODE_PLACEHOLDER", "group code")}
                style={{
                  width:180,
                  height:50,
                  marginTop:10
                }}/>
            </View>
            <View style={{flexDirection:'row', marginTop:4}}>
              <ReUpButton onPress={this.submitGroupRequest} appManager={appManager} text={locMan.localizedStringForKey("JOIN_GROUP_BUTTON", "Join Group")} style={[{margin:10, flex:1}]} />
            </View>
          </View>
        </ScrollView>;

    this.props.appActions.setCustomAlertShown(true,customAlert);
  },

  submitGroupRequest: function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var user = appManager.currentUser();
    var locMan = appManager.getLocalizationManager();
    var thisThing = this;

    appActions.hideAlert();
    appActions.setSpinnerShown(true);
    NetworkManager.joinGroup(appManager, thisThing._groupCode, ()=>
    {
      NetworkManager.login(appManager, user[ModelConstants.UserName], user[ModelConstants.Password], (updatedUser)=>
      {
        appActions.setSpinnerShown(false);
        updatedUser[ModelConstants.Password] = user[ModelConstants.Password];
        appManager.setCurrentUser(updatedUser, function()
        {
          thisThing.forceUpdate();
          appActions.showLocalizedAlert(
            locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_TITLE", "Joined Group"),
            locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_BODY", "You successfully joined the group!"),
            ["OK_ALERT_BUTTON"],[appActions.hideAlert], function(){})
        })
      }, ()=>
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert(
            locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_TITLE", "Joined Group"),
            locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_BODY", "You successfully joined the group!"),
            ["OK_ALERT_BUTTON"],[appActions.hideAlert], function(){})
      }, ()=>
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert(
            locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_TITLE", "Joined Group"),
            locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_BODY", "You successfully joined the group!"),
            ["OK_ALERT_BUTTON"],[appActions.hideAlert], function(){})
      })
    }, ()=>
    {
      appActions.setSpinnerShown(false);  
      thisThing._groupCodeError = true;
      thisThing.showJoinGroup();
      thisThing._groupCodeField.setIsInError(true)
    }, ()=>
    {
      appActions.setSpinnerShown(false);
      thisThing._groupCodeError = true;
      thisThing.showJoinGroup();
      thisThing._groupCodeField.setIsInError(true)
    })
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var feedFeatureData = appManager.getFeatureForName("Feed");
    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);

    if( this.state.user == null || !this.props.appManager.isLoggedIn() ) // early return if we dont have the user yet
    {
      return (
        <View style={styles.container}>
          <Image
            style={[styles.image,{width:this.state.layout.width, height:this.state.layout.height}]}
            source={{uri: bgImage}}
          />
        </View>
      )
    }

    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var logoutButton = locManager.localizedStringForKey("LOGOUT_BUTTON");

    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);

    var user = this.state.user;
    var userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
    var email = user[ModelConstants.UserName];
    var initials = appManager.currentUserInitials();
    var paymentInfo = appManager.getPaymentInfo();

    var profileImageName = appManager.absoluteResourceForPath("Feed/feed_profile_placeholder_admin.png")

    var paymentInfoFeature = appManager.getFeatureForName('PaymentTypes');
    var transactionHistoryFeature = appManager.getFeatureForName('TransactionHistory');

    var tutorialFeature = appManager.getFeatureForName("Tutorial");
    var showTutorial = typeof tutorialFeature !== 'undefined';// && tutorialFeature.data.tutorialImages != "TUTORIAL_IMAGE_LIST";

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <Image
          key={appManager.getImageKey("settingsbg")}
          resizeMode="cover"
          style={{position:'absolute', top:0, left:0, bottom:0, right:0}}
          source={{uri: bgImage}}
        />
        <ReUpScrollView bounces={true} responder={this} >
          <FeedCard settingsFeatureData={this.props.featureData}
            loggedInAsName={userFullName}
            loggedInAsEmail={email}
            logoutText={logoutButton}
            profileImage={profileImageName}
            cardType={3}
            iconColor={bannerIconColor}
            bannerColor={bannerColor}
            cardColor={cardColor}
            titleColor={titleColor}
            bodyColor={bodyColor}
            appManager={appManager}
            profilePicSelected={this.profilePicSelected}
            selfieURL={this.state.selfieURL}
            />
          {
            typeof transactionHistoryFeature !== 'undefined' && transactionHistoryFeature != null ?
            <FeedCard cardType={9}
              iconColor={bannerIconColor}
              bannerColor={bannerColor}
              cardColor={cardColor}
              titleColor={titleColor}
              bodyColor={bodyColor}
              appManager={appManager}
              transactionHistoryFeatureData={transactionHistoryFeature.data}
              changePasswordPressed={this.changePasswordPressed}
              appActions={appActions}
              paymentInfo={paymentInfo}
              loginFacebookPressed={this.loginFacebookPressed}
              joinGroupPressed={this.joinGroupPressed}/> : null
          }
          {
            showTutorial ?
              <FeedCard cardType={10}
                iconColor={bannerIconColor}
                bannerColor={bannerColor}
                cardColor={cardColor}
                titleColor={titleColor}
                bodyColor={bodyColor}
                appManager={appManager}
                tutorialFeatureData={tutorialFeature.data}
                contactSupport={this.contactSupport}
                appActions={appActions}/>
            : null
          }
          <View style={[styles.profileBottomContainer,{paddingTop:0, marginTop:4, paddingBottom:10, paddingLeft: 4, paddingRight: 4}]}>
            <ReUpButton
              isSecondary={true}
              style={[styles.logoutButton]}
              appManager={appManager}
              text={locManager.localizedStringForKey("LOGOUT_BUTTON")}
              onPress={this.logoutPressed}/>
          </View>
          <View style={{height:20}} />
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
    flex: 1
  },
  profileImage: {
    height:80,
    width:80,
    borderRadius:40,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:40,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  passwordContainer: {
    flexDirection:'row',
  },
  profileBottomContainer: {
    flexDirection: 'row',
    alignItems:'stretch',
    justifyContent:'center',
    padding:8,
  },
  logoutButton:{
    flex:1,
  }
});

Settings.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var locManager = appManager.getLocalizationManager();
  var isLoggedIn = appManager.isLoggedIn();
  if( !isLoggedIn ) return [];

  var user = appManager.currentUser();
  var iconName = featureData.data.icon.replace("fa-", "")
  var storeURL = Platform.OS === 'ios' ? user.AppStoreURL : user.PlayStoreURL;

  var cards = [];

  var TRANSACTION_COUNT_FOR_NOT_SHOWING_SELFIE = 2;
  if( false && isLoggedIn && (typeof data.Transactions !== 'undefined') && (data.Transactions.length <= TRANSACTION_COUNT_FOR_NOT_SHOWING_SELFIE) && !appManager._hasSelfie )
  {
    cards.push({
      didSelect : function() {appActions.requestFeatureName("Settings")},
      title : "Profile Selfie",
      body1 : "Head to " + featureData.data.title + " and tap on your initials circle to set your profile selfie!",
      icon : iconName,
      cardType : 0,
      sortOrder : 4
    })
  }

  var TRANSACTION_COUNT_FOR_RATING = 2;
  if( isLoggedIn && (typeof data.Transactions !== 'undefined') && (data.Transactions.length >= TRANSACTION_COUNT_FOR_RATING) && storeURL.length > 0 )
  {
    var sortOrder = 6;
    var transactionIndexForSorting = data.Transactions.length - TRANSACTION_COUNT_FOR_RATING;
    if( transactionIndexForSorting >= 0 && transactionIndexForSorting < data.Transactions.length )
    {
      var transaction = data.Transactions[transactionIndexForSorting];
      var date = transaction.Timestamp;
      var thisDateTime = appManager.getTime(date);
      sortOrder = (new Date()).getTime() - thisDateTime - 10;
    }

    cards.push({
      didSelect : function()
      {
        LinkingManager.openURL(storeURL)
      },
      title : locManager.localizedStringForKey("REVIEW_CARD_TITLE"),
      body1 : locManager.localizedStringForKey("REVIEW_CARD_BODY"),
      icon : "smile-o",
      cardType : 0,
      sortOrder : sortOrder
    })
  }

  return cards;
}

Settings.dataDependencies = ["Users", "Transactions"];

module.exports = Settings;



// WEBPACK FOOTER //
// ./src/Settings.js